// NPM packages
import React from 'react';
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import Link from './Link';
export interface FundingStatementProps {
  className?: string;
}

export const firstSentence = (
  <>
    MSD-LIVE is being developed with support from the{' '}
    <Link to="https://multisectordynamics.org/">
      MultiSector Dynamics
    </Link>{' '}
    program area within the{' '}
    <Link to="https://eesm.science.energy.gov/">
      Earth and Environmental Systems Modeling
    </Link>{' '}
    program of the{' '}
    <Link to="https://www.energy.gov/science/office-science">
      U.S. Department of Energy{'\u2019'}s Office of Science
    </Link>
    .
  </>
);

function FundingStatement(
  props: FundingStatementProps
): React.ReactElement | null {
  const { className } = props;
  return (
    <Typography className={className}>
      {firstSentence} Scoping and brainstorming for MSD-LIVE was also supported
      by the{' '}
      <Link to="https://science.osti.gov/ber/Research/eessd/Data-Management">
        Data Management
      </Link>{' '}
      program.
    </Typography>
  );
}

export default observer(FundingStatement);
